/**
 * Node3D registration: parser and formatter.
 */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseNode3D } from './parser';
import { formatNode3DProperties } from './propertyFormatter';
const node3DRegistration = {
    typeName: 'Node3D',
    parser: parseNode3D,
    propertyFormatter: formatNode3DProperties,
};
nodeRegistry.register(node3DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map